module.exports = __webpack_public_path__ + "static/FY_2021_Announcement_Financial_Result-1e25e41cf40ed46e9afd1aabc11f7053.pdf";